import type { TelegramAuthPayload } from '../api/client';

const WIDGET_CB_NAME = '__vpnsalerTgAuth__';

declare global {
  interface Window {
    [WIDGET_CB_NAME]?: (data: TelegramAuthPayload) => void;
  }
}

/**
 * Mount the official Telegram Login Widget inside ``container``.
 *
 * Note: ``botUsername`` must be the public handle of the bot (without the @),
 * and the bot must have the domain whitelisted via BotFather → Bot Settings →
 * Domain.
 */
export function mountTelegramWidget(
  container: HTMLElement,
  botUsername: string,
  onAuth: (payload: TelegramAuthPayload) => void,
): () => void {
  window[WIDGET_CB_NAME] = onAuth;

  container.innerHTML = '';
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://telegram.org/js/telegram-widget.js?22';
  script.dataset.telegramLogin = botUsername;
  script.dataset.size = 'large';
  script.dataset.radius = '4';
  script.dataset.requestAccess = 'write';
  script.dataset.onauth = `${WIDGET_CB_NAME}(user)`;
  container.appendChild(script);

  return () => {
    container.innerHTML = '';
    delete window[WIDGET_CB_NAME];
  };
}
